export const SearchIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 16.14 16.14"
    >
      <g id="_System_Icons" data-name="*System_Icons">
        <g id="System_Icons" data-name="System/Icons">
          <g id="Group-8">
            <g id="Group-7">
              <g id="atom_icon_search" data-name="atom/icon/search">
                <g
                  id="icon_dark_magnifying-glass"
                  data-name="icon/dark/magnifying-glass"
                >
                  <g id="Mask">
                    <path
                      id="path-1"
                      d="M7,.02C3.14,.02,0,3.16,0,7.02s3.14,7,7,7c1.18,0,2.34-.28,3.32-.82,.08,.09,.17,.18,.26,.26l2,2c.5,.57,1.28,.81,2.01,.63,.74-.18,1.31-.76,1.49-1.49,.18-.74-.06-1.51-.63-2.01l-2-2c-.1-.1-.2-.18-.32-.26,.54-.98,.88-2.12,.88-3.32C14.02,3.14,10.88,0,7.02,0l-.02,.02Zm0,2c2.78,0,5,2.22,5,5,0,1.32-.48,2.54-1.32,3.44-.02,.02-.04,.04-.06,.06-.09,.08-.18,.17-.26,.26-.88,.8-2.08,1.26-3.38,1.26-2.78,0-5-2.22-5-5S4.2,2.04,6.98,2.04l.02-.02Z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
